import React, { useContext, useEffect, useState } from "react";
import { OrderContext } from "../../contexts/OrderContext";

import "../../assets/styles/rejected.css";
import { useNavigate } from "react-router-dom";
import searchIcon from "../../assets/img/icons/search.png"; // update path if needed
import { GiCheckMark } from "react-icons/gi";
import axios from "axios";
import {
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";

const OverdueOrders = () => {
  const { orders, storeData, setUpdateOrderStatusToggle } =
    useContext(OrderContext);
  const { allstatus = [] } = storeData;
  const today = new Date();
  const userRole = localStorage.getItem("userRole");
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [workStatus, setWorkStatus] = useState(0);
  const isMfrOrAdmin = ["mfr", "superadmin", "semimfr", "comfr"].includes(
    userRole?.toLowerCase()
  );
  const [isMobile, setIsMobile] = useState(window.innerWidth < 770);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 770);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const isOverdue = (dateString) => {
    const deliveryDate = new Date(dateString);
    deliveryDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return deliveryDate < today;
  };

  const parseOrderImages = (orderImages) => {
    try {
      // If orderImages is already an array, return it
      if (Array.isArray(orderImages)) {
        return orderImages;
      }
      // If orderImages is a stringified JSON array, parse it
      if (typeof orderImages === "string" && orderImages.startsWith("[")) {
        const parsedImages = JSON.parse(orderImages);

        return parsedImages;
      }
      // If orderImages is a single URL, return it as an array
      return [orderImages];
    } catch (error) {
      console.error("Error parsing order_images:", error);
      return []; // Return an empty array in case of errors
    }
  };

  // Function to get the first image or fallback to the first non-video
  const getFirstImage = (images) => {
    if (images && images.length > 0) {
      const firstItem = images[0];
      // Check if the first item is a video URL (simple check based on extension)
      if (firstItem && firstItem.match(/\.(mp4|mov|wmv|avi)$/i)) {
        // If it's a video, find the first image in the array
        const image = images.find(
          (item) => !item.match(/\.(mp4|mov|wmv|avi)$/i)
        );
        return (
          image || "https://dummyimage.com/150x150/cccccc/ffffff&text=No+Image"
        ); // Fallback if no image found
      }
      return firstItem;
    }
    return "https://dummyimage.com/150x150/cccccc/ffffff&text=No+Image"; // Fallback if no images
  };

  const viewOrderDetails = (order) => {
    navigate("/order-details", { state: { order } });
  };

  const overdueOrders = Object.values(orders)
    .flat()
    .filter((order) => {
      // Determine the date field dynamically based on user role
      const dateField =
        userRole === "Karigar" ? "karigar_delivery_date" : "deliverydate";

      const date = order[dateField]; // Get the date based on user role

      return date && isOverdue(date) && [4].includes(order.work_status_id); // Filter orders where the date is overdue
    });

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredOrders = overdueOrders.filter((order) =>
    order.storeorderno.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const totalWeights = filteredOrders.reduce(
    (acc, order) => {
      const gross = parseFloat(order.weight) || 0;
      const net = parseFloat(order.netwt) || 0;
      const pcs = parseInt(order.pcs) || 0;
      acc.gross += gross;
      acc.net += net;
      acc.pcs += pcs;
      return acc;
    },
    { gross: 0, net: 0, pcs: 0 }
  );
  // Add/remove order from selected list based on checkbox
  const toggleOrderSelection = (storeorderno) => {
    setSelectedOrders((prev) => {
      const exists = prev.includes(storeorderno);
      if (exists) {
        return prev.filter((o) => o !== storeorderno);
      } else {
        return [...prev, storeorderno];
      }
    });
  };

  // Handle Select All toggle
  const handleSelectAll = () => {
    const areAllSelected = filteredOrders.every((order) =>
      selectedOrders.includes(order.storeorderno)
    );

    if (areAllSelected) {
      // Deselect only those currently visible
      const remaining = selectedOrders.filter(
        (sel) => !filteredOrders.find((order) => order.storeorderno === sel)
      );
      setSelectedOrders(remaining);
    } else {
      // Add only the new ones
      const newSelections = filteredOrders
        .map((order) => order.storeorderno)
        .filter((storeorderno) => !selectedOrders.includes(storeorderno));

      setSelectedOrders([...selectedOrders, ...newSelections]);
    }
  };

  const handlestatusChange = (event) => {
    setWorkStatus(event.target.value);
  };

  const handleUpdateWorkStatus = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/orders/updateStatusBulk`,
        {
          storeorderno: selectedOrders,
          work_status_id: workStatus,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      setUpdateOrderStatusToggle((prev) => !prev);
      console.log("Status updated:", response.data);
    } catch (error) {
      console.error("Error updating orders:", error);
    }
  };

  return (
    <div className="new-order-page">
      {/* <div className="headline-container">
        <h1>New Orders</h1>
      </div> */}

      <div
        className="top-row"
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "16px",
          gap: "12px",
          padding: "0 15px",
        }}
      >
        <div
          style={{
            flexBasis: isMobile ? "30%" : "10%", // Full width on mobile
            display: "flex",
          }}
        >
          <button
            onClick={handleSelectAll}
            style={{
              display: "inline-flex", // ✅ Ensure inline row layout
              alignItems: "center",
              justifyContent: "center",
              gap: isMobile ? "6px" : "10px",
              whiteSpace: "nowrap", // ✅ Prevent text/icon from breaking into new line
              border: "none",
              backgroundColor: "#0D7377",
              borderRadius: "8px",
              padding: isMobile ? "6px 8px" : "6px 12px",
              width: "100%",
              color: "#fff",
              fontSize: isMobile ? "14px" : "16px",
              height: "44px",
              fontWeight: 600,
              letterSpacing: 0,
            }}
          >
            Select all <GiCheckMark size={isMobile ? 14 : 18} />
          </button>
        </div>

        <div
          className="search-box"
          style={{
            flexBasis: "30%",
            display: "flex",
            alignItems: "center",
            backgroundColor: "#fff",
            borderRadius: "6px",
            border: "1px solid #D0D5DD",
            padding: "4px 12px",
            height: "44px",
          }}
        >
          <img
            src={searchIcon}
            alt="Search"
            style={{ width: "20px", marginRight: "8px" }}
          />
          <input
            type="text"
            value={searchQuery}
            onChange={handleSearchChange}
            placeholder="Search by Order Number"
            style={{
              border: "none",
              outline: "none",
              width: "100%",
              fontSize: "16px",
            }}
          />
        </div>

        <div
          className="weight-box"
          style={{
            flexBasis: "50%",
            display: "flex",
            justifyContent: "space-between",
            background: "#fff",
            border: "1px solid #E4E7EC",
            alignItems: "center",
            padding: "6px 12px",
            borderRadius: "8px",
            fontSize: "14px",
            height: "44px",
          }}
        >
          <div>
            <strong>Gross:</strong> {totalWeights.gross.toFixed(2)} g
          </div>
          <div>
            <strong>Net:</strong> {totalWeights.net.toFixed(2)} g
          </div>
          <div>
            <strong>Qty:</strong> {totalWeights.pcs}
          </div>
        </div>
      </div>

      <div
        style={{
          width: isMobile ? "100%" : "",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          gap: "10px",
          padding: isMobile ? "12px 10px" : "0 15px",
          position: isMobile ? "sticky" : "static",
          top: isMobile ? 0 : "auto",
          zIndex: isMobile ? 999 : "auto",
          backgroundColor: isMobile ? "#fff" : "transparent",
          boxShadow: isMobile ? "0 2px 6px rgba(0,0,0,0.1)" : "none",
        }}
      >
        <FormControl
          sx={{
            width: isMobile ? "100%" : "400px",
            fontSize: "14px",
          }}
          fullWidth
          size="small"
        >
          <InputLabel id="work-status-label" sx={{ fontSize: "14px" }}>
            Work Status
          </InputLabel>
          <Select
            labelId="work-status-label"
            value={workStatus}
            onChange={handlestatusChange}
            label="Work Status"
            sx={{ fontSize: "14px" }}
          >
            {allstatus.map((status) => (
              <MenuItem
                key={status.id}
                value={status.id}
                sx={{ fontSize: "14px" }}
              >
                {status.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button
          variant="contained"
          color="primary"
          onClick={handleUpdateWorkStatus}
          sx={{
            width: isMobile ? "100%" : "250px",
            fontSize: "14px",
          }}
          disabled={!selectedOrders.length || !workStatus}
        >
          Update Changes
        </Button>
      </div>
      {filteredOrders.length > 0 ? (
        <div
          className="order-list "
          style={{ padding: "0 10px", marginTop: "20px" }}
        >
          {filteredOrders.map((order, index) => {
            // Parse the order_images field
            const images = parseOrderImages(order.order_images);
            // Get the first image (or fallback if it's a video)
            const firstImage = getFirstImage(images);

            const isChecked = selectedOrders.includes(order.storeorderno);

            return (
              <div
                key={index}
                style={{
                  width: isMobile ? "100%" : "",
                  display: "flex",
                  alignItems: "center",
                  border: "1px solid #E4E7EC",
                  borderRadius: "10px",
                  padding: isMobile ? "10px" : "12px",

                  backgroundColor: "#fff",
                  boxShadow: "0 1px 2px rgba(16,24,40,0.06)",
                  cursor: "pointer",
                }}
              >
                {/* Checkbox */}
                <div
                  style={{
                    marginRight: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleOrderSelection(order.storeorderno);
                    }}
                    sx={{ p: 0 }}
                  >
                    {isChecked ? (
                      <CheckBox sx={{ color: "#0D7377" }} />
                    ) : (
                      <CheckBoxOutlineBlank sx={{ color: "#9CA3AF" }} />
                    )}
                  </IconButton>
                </div>

                {/* Image */}
                <div
                  style={{
                    width: isMobile ? "70px" : "80px",
                    height: isMobile ? "70px" : "80px",
                    borderRadius: "8px",
                    overflow: "hidden",
                    border: "1px solid #E4E7EC",
                    flexShrink: 0,
                    marginRight: "10px",
                  }}
                >
                  <img
                    src={firstImage}
                    alt="Order"
                    onError={(e) =>
                      (e.target.src =
                        "https://dummyimage.com/150x150/cccccc/ffffff&text=No+Image")
                    }
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>

                {/* Details */}
                <div
                  onClick={() => viewOrderDetails(order)}
                  style={{
                    flex: 1,
                    fontSize: "13px",
                    color: "#4B5563",
                  }}
                >
                  {userRole !== "Karigar" && order.store_name && (
                    <div
                      style={{
                        fontWeight: "bold",
                        fontSize: "14px",
                        marginBottom: "4px",
                      }}
                    >
                      {order.store_name}
                    </div>
                  )}

                  <div style={{ marginBottom: "4px" }}>
                    <strong>Order No:</strong> {order.storeorderno}
                  </div>

                  <div style={{ marginBottom: "4px" }}>
                    {order.itemtype_name}
                    {order.designno ? ` | ${order.designno}` : ""}
                  </div>

                  {order.pcs && (
                    <div style={{ marginBottom: "4px" }}>
                      Qty: {order.pcs}
                      {isMfrOrAdmin &&
                        order.karigar_name &&
                        ` | ${order.karigar_name}`}
                    </div>
                  )}

                  <div
                    style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}
                  >
                    {(userRole === "Karigar"
                      ? order.karigar_delivery_date
                      : order.deliverydate) && (
                      <span style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={require("../../assets/img/icons/delivery.png")}
                          alt="Delivery"
                          style={{ width: "16px", marginRight: "4px" }}
                        />
                        {userRole === "Karigar"
                          ? order.karigar_delivery_date
                          : order.deliverydate}
                      </span>
                    )}
                    {order.weight && (
                      <span style={{ display: "flex", alignItems: "center" }}>
                        <img
                          src={require("../../assets/img/icons/wt.png")}
                          alt="Weight"
                          style={{ width: "16px", marginRight: "4px" }}
                        />
                        {order.weight}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <p className="no-orders">No orders found.</p>
      )}
    </div>
  );
};

export default OverdueOrders;
